<p-menubar class="navbar" [styleClass]="!!(patient$ | async) ? '' : 'empty-menubar'" [model]="menuItems">
  <ng-template pTemplate="start">
    <div class="flex align-items-center mr-8">
      <a routerLink="/"
        ><img src="assets/images/my-ccs-med-logo.svg" height="38" data-cy="ccs-logo" alt="My CCS Med Logo"
      /></a>
    </div>
  </ng-template>
  <ng-template pTemplate="end">
    <app-user-menu [isDesktop]="isDesktopVersion"></app-user-menu>
  </ng-template>
</p-menubar>
